import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="create-community-space"
export default class extends Controller {
  static targets = ["nameInput", "intakeInput", "nameError", "intakeError"]
  static values = { createUrl: String, selectId: String }

  connect() {
    this.select = document.getElementById(this.selectIdValue)?.tomselect
    this.initName = this.nameInputTarget.value
  }

  disconnect() {
    this.clearData()
  }

  setData(event) {
    this.nameInputTarget.value = event.detail.value
    this.select = event.detail.select
  }

  create() {
    const name = this.nameInputTarget.value.trim()
    const intake = this.intakeInputTarget.value.trim()

    const payload = {
      community_space: { name, intake }
    }

    fetch(this.createUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then(data => {
        if (data.errors) {
          this.handleErrors(data.errors)
          return
        }

        this.addOptionToSelect(data)
        this.clearData()
        this.closeModal()
      })
      .catch(error => {
        console.error("Error creating community space:", error)
      })
  }

  handleErrors(errors) {
    this.toggleError(this.nameErrorTarget, errors.name)
    this.toggleError(this.intakeErrorTarget, errors.intake)
  }

  toggleError(target, message) {
    target.textContent = message || ""
    target.classList.toggle("hidden", !message)
    target.classList.toggle("error", !!message)
  }

  addOptionToSelect(data) {
    const label = data.label
    const value = data.value
    this.select.addOption({ label, value })
    this.select.removeOption(label)
    this.select.addItem(value)
  }

  close() {
    this.clearSelectOption()
    this.clearData()
    this.closeModal()
  }

  clearSelectOption() {
    this.select.removeItem(this.initName)
    this.select.removeOption(this.initName)
  }

  clearData() {
    this.nameInputTarget.value = ""
    this.intakeInputTarget.value = ""
    this.initName = ""
    this.select = null
  }

  closeModal() {
    document.dispatchEvent(new CustomEvent("modal:hide"))
  }
}
